module.exports = __webpack_public_path__ + "img/palm.12e52bef.png";